import { JobsiteForOption, JobsiteOptionElement } from './types';

export const getJobsitesOptions = (
  jobsites: JobsiteForOption[],
): JobsiteOptionElement[] =>
  jobsites
    ?.map(({ jobsiteId: value, name: label, startDate }) => ({
      value,
      label,
      startDate,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
